import { render } from "./Transfers.vue?vue&type=template&id=55304dc4"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"

import "./Transfers.vue?vue&type=style&index=0&id=55304dc4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Transfers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55304dc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55304dc4', __exports__)) {
    api.reload('55304dc4', __exports__)
  }
  
  module.hot.accept("./Transfers.vue?vue&type=template&id=55304dc4", () => {
    api.rerender('55304dc4', render)
  })

}


export default __exports__